import { default as React, useState, useRef, useEffect, useMemo, createRef, useContext, useSearchParams } from 'react'
import { Form, useNavigate } from 'react-router-dom'
import Page from '../layout/Page'
import { Button, Grid, Paper, Select, Typography, FormControl, InputLabel, MenuItem } from '@mui/material'
import { TaskAlt, TableRows } from '@mui/icons-material'
import ConfirmDialog from '../form/ConfirmDialog'
import { getRequestConfig, getToken } from '../auth/auth'
import axios from 'axios'
import { ApiGateway } from '../config/config'
import { Stack } from '@mui/system'
import RichEditor from '../form/RichEditor'
import AuthorizationLetterTemplate from '../authorizations/AuthorizationLetterTemplate'
import FormViewCommandBar from '../commandBar/FormViewCommandBar'
import { default as bus } from '../utils/EventBus'
import Event from '../utils/EventNames.js';
import RoleContext from '../auth/RoleContext.js'
import ListViewCommandBar from '../commandBar/ListViewCommandBar.js'
import ListExtendedAttributes from './ListExtendedAttributes.js'


const ALERT_DURATION = 1000

export default function ManageExtendedAttributesPage (props = {}) {
  const roleDetails = useContext(RoleContext)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const [listRefreshKey, setListRefreshKey] = useState(new Date().toISOString())
  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const addRecord = () => {
    console.log('add record')
    bus.emit('add-extended-attribute')
  }


  const breadcrumb = <span><span onClick={e => navigate('/app/admin')}> <a href="#">Application Administration</a></span> {'>'} Manage Extended Attributes</span>

  const [showFilters, setShowFilters] = useState(false)
  const toggleFilters = () => {
    setShowFilters(!showFilters)
  }

  return (
    <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} 
    commandBar={
      <ListViewCommandBar 
        showFilters={true}
        toggleFilters={toggleFilters} 
        addRecord={addRecord} 
        showAdd={true}              
      />
    }>
      <Paper sx={{margin: '0 auto 1em auto' }}>
          <ListExtendedAttributes
            key={listRefreshKey}
            showFilters={showFilters}
            startLoading={startLoading}
            stopLoading={stopLoading}
            searchFilter={{isActive: false}}
            refresh={() => setListRefreshKey(new Date().toISOString())}
          />
      </Paper>
  </Page>
  )
}